import { useEffect, useRef, useState } from 'react';
import { useAuthContext } from '../../hooks/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from 'react-helmet-async';
import style from './style.module.scss';
import { displayWarning } from "../../utils/messageToast";
import { tabulateTickets } from '../../functions/tabulateTickets';
import { TextAreaErrors, TextAreaField } from '../../components/ui/textArea';

export default function Tabulation() {
  const { authorization, user, authorizationRA, signOut } = useAuthContext();
  const ambient = user?.ambient as string;
  const [loadingButton, setLoadingButton] = useState(false);
  const [tabId, setTabId] = useState('');
  const [protocols, setProtocols] = useState<any[]>([]);
  const [textAreaValue, setTextAreaValue] = useState<string>('');
  const [publicNote, setPublicNote] = useState<string>('');
  const [privateNote, setPrivateNote] = useState<string>('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isErrors, setIsErrors] = useState(false);
  const [errors, setErrors] = useState<any[]>([]);

  const useIsomorphicEffect = useEffect;
  const [cacheCleared, setCacheCleared] = useState(false);

  useIsomorphicEffect(() => {
    const executeClearCache = async () => {
      await clearCacheClient();
    };
    executeClearCache();

  }, []);

  const clearCacheClient = async () => {
    try {
      const cacheKeys = await caches.keys();
      if (cacheKeys.length > 0) {
        await Promise.all(cacheKeys.map(key => caches.delete(key)));
        setCacheCleared(true);
      }
    } catch (error: any) {
      return error
    }
  };

  const handleTextAreaValue = async (value: string) => {
    const lines = value.split('\n').map(line => ({ protocol: line }));
    setProtocols(lines);
  }

  const handleTabulation = async () => {
    setLoadingButton(true);
    await new Promise((resolve) => setTimeout(resolve, 3000));
    await tabulateTickets(tabId, setTabId, ambient, authorization, authorizationRA, setTextAreaValue, publicNote, setPublicNote, privateNote, setPrivateNote, protocols, setProtocols, setIsErrors, setErrors, signOut);
    setLoadingButton(false);
    setIsModalOpen(false);
  };

  return (
    <div>
      <Helmet>
        <title>Tech Forms - Tabulação em massa</title>
      </Helmet>

      <div className={style.container}>
        <div className={style.containerMain}>

          <div className={style.items}>

            <input
              className={style.inputTabId}
              placeholder="Insira a tabId de destino"
              type="text"
              value={tabId}
              onChange={(e) => setTabId(e.target.value)}
            />

            <input
              className={style.inputTabId}
              placeholder="Insira a nota publica"
              type="text"
              value={publicNote}
              onChange={(e) => setPublicNote(e.target.value)}
            />

          </div>

          <div className={style.items}>

            <input
              className={style.inputTabId}
              placeholder="Insira a nota privada"
              type="text"
              value={privateNote}
              onChange={(e) => setPrivateNote(e.target.value)}
            />

            <button
              className={style.buttonSend}
              onClick={async () => {
                if (tabId === '') {
                  displayWarning("Insira a tabId de destino!");
                  return;
                }
                if (textAreaValue === '') {
                  displayWarning("Insira os protocolos!");
                  return;
                }
                setIsModalOpen(true)
              }}
            >
              {!loadingButton ? (
                <a>Tabular</a>
              ) : (
                <FontAwesomeIcon icon={faSpinner} spin />
              )}
            </button>

          </div>
        </div>

        <TextAreaField
          value={textAreaValue}
          className={style.jsonTextarea}
          placeholder=""
          // readOnly
          onChange={(e) => {
            setTextAreaValue(e.target.value);
            handleTextAreaValue(e.target.value);
          }}
        />

        {isErrors && (
          <>
            <h3 >Errors</h3>
            <TextAreaErrors
              value={errors}
              className={style.jsonTextareaErrors}
              readOnly
            />
          </>
        )}

        {isModalOpen && (
          <div className={style.modal}>
            <div className={style.modalContent}>
              {!loadingButton && (
                <p style={{ marginBottom: '20px' }}>Confirma a tabulação dos tickets?</p>
              )}

              {loadingButton && (
                <div style={{ display: 'flex', justifyContent: 'center', width: '150px' }}>
                  <h4>
                    Tabulando
                    <span className={style.loadingText}></span>
                  </h4>
                </div>
              )}

              <div className={style.modalActions}>
                {!loadingButton && (
                  <>
                    <button
                      className={style.modalButton}
                      onClick={handleTabulation}
                    >
                      Confirmar
                    </button>

                    <button
                      className={style.modalButton}
                      onClick={() => setIsModalOpen(false)}
                    >
                      Cancelar
                    </button>
                  </>
                )}
              </div>

            </div>
          </div>
        )}

      </div>
    </div>
  );
}
